import React, { Component, Fragment } from 'react';

import { CreateTransactionPageForm } from './../createTransaction/CreateTransactionForm';
import { LoadingPage, DirtyWrapper } from 'Components';
import { Filter, Main } from 'Containers';
import { formValueSelector } from 'redux-form';
import { CREATE_TRANSACTION_FORM_NAME } from 'Common/FormEnum';
import { TransactionSummaryEnum } from 'Common/FieldEnum';
import { connect } from 'react-redux';
import {
  getPhysicalForTranSummary,
  getTranPreview,
  clearCreateTransactionSummaryError,
  closePeriod,
  getOpenTransactionWarning,
  showWarningMsg,
  clearGetPhysicalGridData,
  setBeginDT,
  setEndDT,
} from '../../state/CreateTransaction/actions';
import {
  getTranBeginEndDate,
  clearTransactionSummaryError,
} from './../../state/TransactionSummaryList/actions';
import { resetForm } from 'State/forms/actions';
import moment from 'moment';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { errorToast } from 'Common/ToastHelper';
import { PrintOptionsEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { resetDirty } from 'State/dirtyTracking/actions';
import { clearTableSavedState } from 'Common/FormHelper';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { setTableStates } from 'Common/UserSettings/state/actions';
import { getTableStates } from 'Common/UserSettings/helpers/helper';

const currentDate = moment();
export const BASE_URL = '/transactionSummary/create';
class CreateTransactionPage extends Component {
  static path = BASE_URL;
  state = {
    fromDateMax: null,
    toDateMin: null,
    render: false,
    beginDate: currentDate.format(DATE_FORMAT_FOR_UI),
    endDate: currentDate.add(1, 'month').format(DATE_FORMAT_FOR_UI),
  };
  componentDidUpdate(prevProps) {
    const {
      clearCreateTransactionSummaryError,
      fetchTransactionBeginEndDateLoadingError,
      clearTransactionSummaryError,
    } = this.props;
    if (
      errorToast(
        this.props,
        prevProps,
        'fetchTransactionBeginEndDateLoadingError'
      ) ||
      errorToast(
        this.props,
        prevProps,
        'fetchExistingTranSummaryPreviewLoadingError'
      ) ||
      errorToast(this.props, prevProps, 'closePeriodLoadingError') ||
      errorToast(
        this.props,
        prevProps,
        'fetchOpenTransactionWarningMsgLoadingError'
      )
    ) {
      fetchTransactionBeginEndDateLoadingError &&
        this.setState({ render: true });
      clearTransactionSummaryError();
      clearCreateTransactionSummaryError();
    }
  }
  componentDidMount() {
    const { getTranBeginEndDate } = this.props;
    getTranBeginEndDate().then(() => {
      const { transactionBeginEndDate } = this.props;
      let beginDate = moment(
        transactionBeginEndDate[TransactionSummaryEnum.EndDT]
      )
        .add(1, 'days')
        .startOf('month')
        .format(DATE_FORMAT_FOR_UI);
      let endDate = moment(
        transactionBeginEndDate[TransactionSummaryEnum.EndDT]
      )
        .add(1, 'months')
        .endOf('month')
        .format(DATE_FORMAT_FOR_UI);
      this.props.setBeginDT(beginDate);
      this.props.setEndDT(endDate);
      this.setState({
        toDateMin: moment(beginDate, DATE_FORMAT_FOR_UI),
        fromDateMax: moment(endDate, DATE_FORMAT_FOR_UI),
        render: true,
        beginDate,
        endDate,
      });
      this.props.resetDirty();
    });
  }

  componentWillUnmount() {
    this.props.clearGetPhysicalGridData();
    this.clearTableSavedState();
  }

  clearTableSavedState = () => {
    const { history, allTableStates, setTableStates } = this.props;
    clearTableSavedState(history, BASE_URL, allTableStates, setTableStates, [
      TableNamesEnum.CREATE_TRANSACTION_SUMMARY_TABLE,
    ]);
  };

  getBreadCrumbs = () => {
    let breadcrumbs = [
      {
        title: 'Transaction Summary',
        link: '/transactionSummary',
      },
      {
        title: 'Create Transaction',
        link: '',
      },
    ];
    return breadcrumbs;
  };
  getRootUrl = () => {
    return '/transactionSummary';
  };
  getMainProps = showDirtyConfirm => {
    return {
      toolbox: {
        backButtonProps: { shown: true, path: this.getRootUrl() },
        rightButtons: [],
        shown: true,
      },
    };
  };
  onCancelClick = () => {
    this.props.history.push('/transactionSummary');
  };

  render() {
    const {
      fetchTransactionBeginEndDateLoading,
      fetchOpenTransactionWarningMsgLoading,
      isReadOnly,
    } = this.props;
    const { render, beginDate, endDate } = this.state;

    return (
      <Fragment>
        {(fetchTransactionBeginEndDateLoading ||
          fetchOpenTransactionWarningMsgLoading) && <LoadingPage />}
        <Filter title={''} breadcrumbs={this.getBreadCrumbs()} />
        <DirtyWrapper closeModalYesCallback={this.onCancelClick}>
          {showDirtyConfirm => (
            <Main
              {...this.getMainProps(showDirtyConfirm)}
              isReadOnly={isReadOnly}
              shouldNotUsePageWidth
            >
              {render && (
                <CreateTransactionPageForm
                  {...this.props}
                  initialValues={{
                    [TransactionSummaryEnum.BeginDT]: beginDate,
                    [TransactionSummaryEnum.EndDT]: endDate,
                    [TransactionSummaryEnum.PrintOptions]:
                      PrintOptionsEnum.ItemCode,
                    [TransactionSummaryEnum.ShowDetails]: false,
                  }}
                  fromDateMax={this.state.fromDateMax}
                  toDateMin={this.state.toDateMin}
                />
              )}
            </Main>
          )}
        </DirtyWrapper>
      </Fragment>
    );
  }
}
const mapDispatchToProps = {
  getTranBeginEndDate,
  getPhysicalForTranSummary,
  getTranPreview,
  resetForm,
  clearCreateTransactionSummaryError,
  closePeriod,
  getOpenTransactionWarning,
  showWarningMsg,
  clearGetPhysicalGridData,
  resetDirty,
  setBeginDT,
  setEndDT,
  clearTransactionSummaryError,
  setTableStates,
};

const selector = formValueSelector(CREATE_TRANSACTION_FORM_NAME);
const mapStateToProps = state => {
  const {
    transactionSummaryList,
    createTransactionSummary,
  } = state.TransactionSummaryState;

  const {
    transactionBeginEndDate,
    fetchTransactionBeginEndDateLoading,
    fetchTransactionBeginEndDateLoadingError,
  } = transactionSummaryList;
  const {
    physicalForTranSummaryList,
    fetchPhysicalForTranSummaryListLoadingError,
    fetchPhysicalForTranSummaryListLoading,
    fetchExistingTranSummaryPreviewLoading,
    fetchExistingTranSummaryPreviewLoadingError,
    closePeriodLoading,
    closePeriodLoadingError,
    fetchOpenTransactionWarningMsgLoading,
    fetchOpenTransactionWarningMsg,
    fetchOpenTransactionWarningMsgLoadingError,
    showWarningDialog,
  } = createTransactionSummary;

  return {
    transactionBeginEndDate: transactionBeginEndDate,
    beginDT: selector(state, TransactionSummaryEnum.BeginDT),
    endDT: selector(state, TransactionSummaryEnum.EndDT),
    printOptionsValue: selector(state, TransactionSummaryEnum.PrintOptions),
    showDetails: selector(state, TransactionSummaryEnum.ShowDetails),
    physicalForTranSummaryList,
    fetchPhysicalForTranSummaryListLoadingError,
    fetchPhysicalForTranSummaryListLoading,
    fetchTransactionBeginEndDateLoading,
    fetchTransactionBeginEndDateLoadingError,
    fetchExistingTranSummaryPreviewLoading,
    fetchExistingTranSummaryPreviewLoadingError,
    closePeriodLoading,
    closePeriodLoadingError,
    fetchOpenTransactionWarningMsgLoading,
    fetchOpenTransactionWarningMsg,
    fetchOpenTransactionWarningMsgLoadingError,
    showWarningDialog,
    allTableStates: getTableStates(state),
  };
};

export const CreateTransaction = connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateTransactionPage);



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/transactionSummary/containers/subpages/CreateTransaction.js